var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("img", {
      staticClass: "card-img-top img1",
      attrs: { src: _vm.itemImage },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("dl", [
        _c("dt", [_vm._v("\n                Status\n            ")]),
        _vm._v(" "),
        _c("dd", [
          _c(
            "span",
            {
              staticClass: "badge",
              class: _vm.$store.getters["subjectids/statusColor"](_vm.item),
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$store.getters["subjectids/statusText"](_vm.item)
                  ) +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "label",
            {
              staticClass: "col-form-label",
              attrs: { for: `student_identification__notes_${_vm.index}` },
            },
            [_vm._v("Notes")]
          ),
          _vm._v(" "),
          _c("wysiwyg", {
            attrs: { id: `student_identification__notes_${_vm.index}` },
            model: {
              value: _vm.item.submitted_notes,
              callback: function ($$v) {
                _vm.$set(_vm.item, "submitted_notes", $$v)
              },
              expression: "item.submitted_notes",
            },
          }),
          _vm._v(" "),
          _vm.errors["submitted_notes"]
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.errors["submitted_notes"]) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.action === "submit"
      ? _c("div", { staticClass: "card-footer" }, [_vm._m(0)])
      : _c("div", { staticClass: "card-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-block sgp-btn-default",
              on: {
                click: function ($event) {
                  return _vm.onSubmit("Submitted - APPROVED")
                },
              },
            },
            [_vm._v("\n            Submitted - APPROVED\n        ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-block sgp-btn-default",
              on: {
                click: function ($event) {
                  return _vm.onSubmit("Submitted - CHANGES REQUESTED")
                },
              },
            },
            [_vm._v("\n            Submitted - CHANGES REQUESTED\n        ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("i", { staticClass: "fas fa-2x fa-cog fa-spin" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }